const handleScroll = () => {
  if (window.scrollY > window.innerHeight) {
    document.body.classList.add("has-scrolled")
  } else {
    document.body.classList.remove("has-scrolled")
  }
}

// Check on load
handleScroll()

// Debounced scroll
let scrollTimeout
window.addEventListener(
  "scroll",
  () => {
    clearTimeout(scrollTimeout)
    scrollTimeout = setTimeout(handleScroll, 10)
  },
  { passive: true },
)
